// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._11c81o8v{font:var(--ds-font-body-small,normal 400 11px/1pc ui-sans-serif,-apple-system,BlinkMacSystemFont,\"Segoe UI\",Ubuntu,\"Helvetica Neue\",sans-serif)}\n._zulp1b66{gap:var(--ds-space-050,4px)}\n._1e0c1txw{display:flex}\n._4cvr1h6o{align-items:center}\n._bozgv77o{padding-inline-start:var(--ds-space-025,2px)}", ""]);
// Exports
module.exports = exports;
